import { VisionCountMode, type VisionPlan } from "@sitescene/types";

const PALETTE = [
	"#22c55e",
	"#3b82f6",
	"#f97316",
	"#e11d48",
	"#a855f7",
	"#14b8a6",
	"#eab308",
	"#ec4899",
];

/** A stable color per class name, the same on the boxes and in the lists. */
export const classColor = (name: string): string => {
	let hash = 0;
	for (const char of name) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
	return PALETTE[hash % PALETTE.length] as string;
};

/** Seconds from the start of the video as m:ss. */
export const formatSeconds = (seconds: number): string => {
	const whole = Math.max(0, Math.floor(seconds));
	return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, "0")}`;
};

/** Ready to run: something to look for, and the line or area drawn if the count needs one. */
export const planIsRunnable = (plan: VisionPlan): boolean => {
	const targets = (plan.geminiTargets ?? []).filter((target) =>
		target.label.trim(),
	);
	if (!plan.detect.classes.length && !targets.length) return false;
	if (plan.count?.mode === VisionCountMode.Line && !plan.count.line)
		return false;
	if (plan.count?.mode === VisionCountMode.Area && !plan.count.area)
		return false;
	return true;
};
